import { Link, useLocation } from "react-router-dom";
import Header from "../../Layout/Header";
import Profilemenu from "./Profilemenu";
import "./MyBooking.css";
import { useEffect, useState } from "react";
import {
  caregivermarktaskcomplete,
  caregiverupcomingbooking,
  endjob,
  getBookingTask,
  startjob,
  stripeurl,
} from "../../service/Mainservice";
import Loader from "../../Loader/Loader";
import Pagination from "../../Pagination/Pagination";
import { Alert, Snackbar } from "@mui/material";
import KYCPopup from "./KYC";
import moment from "moment";

// import { messaging } from "../../Firebase";
// import { getToken } from "firebase/messaging";

const CaregiverUpcomingbook = () => {
  const [list, setlist] = useState();
  const [devicetoken, setdevicetoken] = useState();
  const [load, setload] = useState(true);
  const [openTasks, setOpenTasks] = useState({});
  const [markingTaskId, setMarkingTaskId] = useState(false);
  const [error, seterror] = useState(false);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [success, setsuccess] = useState();
  const [currentPage, setcurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState();
  const [kyc, setkyc] = useState();
  const [url, seturl] = useState(false);

  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    // const requestNotificationPermission = async () => {
    //   try {
    //     const permissionResult = await Notification.requestPermission();
    //     console.log(permissionResult);
    //     if (permissionResult === "granted") {
    //       const currentToken = await getToken(messaging, {
    //         vapidKey:
    //           "BOS2jENcfmydQnDnOwt6HvXqiYV4u8XQ0ay2_eYlLdj8B7THtDnKgYKKnvXR-LXRsEVsYqBOsvuLTnh10AE0rRc",
    //       });
    //       console.log(currentToken);
    //       setdevicetoken(currentToken);
    //       // Use the token as needed
    //     }
    //   } catch (error) {
    //     console.error("Error obtaining device token:", error);
    //   }
    // };

    // requestNotificationPermission();
    getupcoming(1);
    checkstripe();
  }, []);

  const checkstripe = async () => {
    const response = await stripeurl();
    console.log(response);
    if (response.data.url) {
      seturl(response.data.url);
      setkyc(true);
    }
  };

  const getupcoming = async (val = 1) => {
    try {
      const response = await caregiverupcomingbooking(val);
      const bookingList = response.data.data || [];
      const bookingWithTasks = await Promise.all(
        bookingList.map(async (booking) => {
          try {
            const taskResponse = await getBookingTask(booking.id);
            return {
              ...booking,
              tasks: taskResponse.data?.data || [],
            };
          } catch (error) {
            console.log(error);
            return {
              ...booking,
              tasks: [],
            };
          }
        }),
      );
      setlist(bookingWithTasks);
      setcurrentPage(response.data.pagination.current_pages);
      settotalPages(response.data.pagination.total_pages);

      setload(false);
    } catch (error) {
      console.log(error);
      setload(false);
    }
  };

  const handlestartjob = async (id) => {
    setload(true);
    try {
      const response = await startjob(id, devicetoken);
      console.log(response);
      getupcoming();
      setload(false);
      setOpen2(true);
      setsuccess(response.data.message);
    } catch (error) {
      console.log(error);
      seterror(error.message);
      setOpen(true);
      setload(false);
    }
  };
  const handleendjob = async (id) => {
    setload(true);

    try {
      const response = await endjob(id, devicetoken);
      getupcoming();
      setload(false);
      setOpen2(true);
      setsuccess(response.data.message);
    } catch (error) {
      seterror(error.message);
      setload(false);
      setOpen(true);
      setload(false);
    }
  };
  const toggleTasks = (id) => {
    setOpenTasks((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  const handlemarktaskcomplete = async (taskId) => {
    setMarkingTaskId(taskId);
    try {
      const response = await caregivermarktaskcomplete(taskId);
      setsuccess(response.data.message);
      setOpen2(true);
      getupcoming(currentPage);
    } catch (error) {
      console.log(error);
      seterror(error.message || "Unable to complete task");
      setOpen(true);
    } finally {
      setMarkingTaskId(false);
    }
  };

  return (
    <>
      <Header title="My Booking" headerbg="upcomingbg" />
      <div className="editprofile_data">
        <Profilemenu />
        <div className="editprofile_info">
          <h2 className="editprofile_maintitle">My Booking</h2>
          <div className="booking_status">
            <Link
              to="/CompanionUpcomingbook"
              className={
                path === "/CompanionUpcomingbook"
                  ? "booking_status_title selected_title"
                  : "booking_status_title"
              }
            >
              Upcoming
            </Link>
            <Link
              to="/CompanionCompletedbook"
              className={
                path === "/CompanionCompletedbook"
                  ? "booking_status_title selected_title"
                  : "booking_status_title"
              }
            >
              Completed
            </Link>
          </div>
          {list ? (
            <div>
              <div className="mybooking_cardlist">
                {list.map((data) => (
                  <div className="mybooking_card modern_card">
                    <div className="mybooking_card_section">
                      {data.is_today_job ? (
                        <p className="mybooking_today">
                          Current Service Date: {moment().format("MM/DD/YYYY")}{" "}
                          at {data.booking_time}
                        </p>
                      ) : (
                        ""
                      )}
                      <div className="section_title_div">
                        <p className="section_title">📄 Booking Info</p>
                        <p className="booking_type_badge">
                          {data.booking_type}
                        </p>
                      </div>
                      <div className="mybooking_card_row">
                        <div className="mybooking_cardinfo1">
                          <p>Request ID</p>
                          <h3>{data.request_id}</h3>
                        </div>
                        <div className="mybooking_cardinfo1">
                          <p>Booking Hr</p>
                          <h3>{data.booking_hours || "N/A"}</h3>
                        </div>
                        <div className="mybooking_cardinfo1">
                          <p>Start Date</p>
                          <h3>
                            {moment(data.start_booking_date).format("MM/DD/YY")}
                          </h3>
                        </div>
                        {data.booking_type === "OneTime" && (
                          <div className="mybooking_cardinfo1">
                            <p>End Date</p>
                            <h3>
                              {" "}
                              {moment(data.end_booking_date).format("MM/DD/YY")}
                            </h3>
                          </div>
                        )}
                      </div>
                      <div className="mybooking_card_row">
                        {data.booking_type === "Recurring" &&
                          data.recurring_days.length > 0 && (
                            <div className="mybooking_cardinfo1">
                              <p>Recurring Days</p>
                              <div className="mybooking_days_div">
                                {data.recurring_days.map((day) => (
                                  <h3 className="mybooking_days">
                                    {day.trim()}
                                  </h3>
                                ))}
                              </div>
                            </div>
                          )}
                        {data.booking_type === "Flexible" &&
                          data.flexible_dates.length > 0 && (
                            <div className="mybooking_cardinfo1">
                              <p>Flexible Dates</p>
                              <div className="mybooking_days_div">
                                {data.flexible_dates.map((day) => (
                                  <h3 className="mybooking_days">
                                    {moment(day.trim()).format("MM/DD/YY")}
                                  </h3>
                                ))}
                              </div>{" "}
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="mybooking_card_section">
                      <p className="section_title">👤 Client Info</p>
                      <div className="mybooking_card_row">
                        <div className="mybooking_cardinfo1">
                          <h3 className="mybooking_caretakerdata">
                            <img
                              src={`${process.env.REACT_APP_IMAGE_URL}${data.client_pic}`}
                              alt="client"
                              loading="lazy"
                            />
                            {data.client_name}
                          </h3>
                        </div>
                        {/* <div className="mybooking_cardinfo">
                          <p>Country Code</p>
                          <h3>{data.client_country_code}</h3>
                        </div> */}
                        <div className="mybooking_cardinfo">
                          <p>Phone Number</p>
                          <h3>{data.client_phone_number}</h3>
                        </div>
                      </div>
                      <div className="mybooking_card_row">
                        <div className="mybooking_cardinfo1">
                          <p>Time</p>
                          <h3>{data.booking_time}</h3>
                        </div>
                        <div className="mybooking_cardinfo1">
                          <p>Address</p>
                          <h3>{data.address}</h3>
                        </div>
                      </div>
                    </div>
                    <div className="mybooking_card_section mybooking_task_section">
                      <button
                        type="button"
                        className="mybooking_task_toggle"
                        onClick={() => toggleTasks(data.id)}
                      >
                        <div>
                          <p className="section_title mybooking_task_title">
                            Tasks
                          </p>
                          <p className="mybooking_task_count">
                            {data.tasks?.length || 0} task
                            {data.tasks?.length === 1 ? "" : "s"}
                          </p>
                        </div>
                        <span
                          className={`mybooking_task_arrow ${
                            openTasks[data.id] ? "open" : ""
                          }`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-chevron-down-icon lucide-chevron-down"
                          >
                            <path d="m6 9 6 6 6-6" />
                          </svg>{" "}
                        </span>
                      </button>
                      {openTasks[data.id] &&
                        (data.tasks?.length > 0 ? (
                          <div className="mybooking_task_list">
                            {data.tasks.map((task) => (
                              <div
                                className="mybooking_task_item"
                                key={task.id}
                              >
                                <div className="mybooking_task_content">
                                  <h4>{task.task}</h4>
                                  <p>{task.task_time}</p>
                                </div>
                                <div className="mybooking_task_action_group">
                                  {task.status === "pending" ? (
                                    <label className="mybooking_task_checkbox">
                                      <input
                                        type="checkbox"
                                        checked={false}
                                        disabled={markingTaskId === task.id}
                                        onChange={() =>
                                          handlemarktaskcomplete(task.id)
                                        }
                                      />
                                      <span>
                                        {markingTaskId === task.id
                                          ? "Saving..."
                                          : "Mark as complete"}
                                      </span>
                                    </label>
                                  ) : (
                                    <span className="mybooking_task_checkbox">
                                      {task.date_completed}
                                    </span>
                                  )}
                                  <span
                                    className={`mybooking_task_status ${
                                      task.status === "completed"
                                        ? "completed"
                                        : "pending"
                                    }`}
                                  >
                                    {task.status}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p className="mybooking_task_empty">No tasks added</p>
                        ))}
                    </div>

                    {data.booking_status === "2" ? (
                      <p
                        className="mybooking_help modern_action"
                        onClick={() => handlestartjob(data.id)}
                      >
                        Start Job
                      </p>
                    ) : data.booking_status === "3" ? (
                      <p
                        className="mybooking_help modern_action"
                        onClick={() => handleendjob(data.id)}
                      >
                        End Job
                      </p>
                    ) : (
                      <p className="mybooking_help modern_action">
                        Booking Completed
                      </p>
                    )}
                  </div>
                ))}
              </div>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                getorderlist={getupcoming}
              />
            </div>
          ) : (
            <div className="blank_booking">No Upcoming Bookings</div>
          )}
        </div>
      </div>
      {load && <Loader />}
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert variant="filled" severity="error">
          {error}
        </Alert>
      </Snackbar>
      <Snackbar
        open={open2}
        autoHideDuration={3000}
        onClose={() => setOpen2(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert variant="filled" severity="success">
          {success}
        </Alert>
      </Snackbar>
      <KYCPopup isOpen={kyc} setisOpen={setkyc} url={url} />
    </>
  );
};
export default CaregiverUpcomingbook;
